module.exports = "/images/vendor/flag-icon-css/flags/1x1/kr.svg?7fb0181b38e9efdb9bc5b9dca3e90051";